import { CheckCircle, DescriptionOutlined } from "@mui/icons-material";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import React from "react";

export default function ButtonDocsInput({
  item,
  active,
  completed,
  uploadedCount,
  totalCount,
  accept,
  multiple = true,
  onPickFiles,
  onSelectType,
  openOnTap = true,
}) {
  const handleChange = (event) => {
    onPickFiles?.(event?.target?.files, item);
    if (event?.target) event.target.value = "";
  };

  const handleClick = (event) => {
    onSelectType?.(item);
    if (!openOnTap) event.preventDefault();
  };

  return (
    <Button
      component="label"
      variant={active ? "contained" : "outlined"}
      color={completed ? "success" : active ? "primary" : "inherit"}
      onClick={handleClick}
      sx={{
        p: 1.2,
        minHeight: { xs: 112, sm: 118 },
        borderRadius: 2,
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        gap: 1,
        position: "relative",
      }}
    >
      <Stack
        direction="column"
        spacing={0.8}
        alignItems="center"
        justifyContent="center"
        sx={{ width: "100%" }}
      >
        <DescriptionOutlined sx={{ fontSize: 32 }} />
        <Typography
          variant="caption"
          sx={{ fontWeight: 700, lineHeight: 1.3, whiteSpace: "normal" }}
        >
          {item.label}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={0.6} alignItems="center">
        <Typography variant="caption">
          {uploadedCount > 0
            ? `${uploadedCount} subido(s)`
            : `${totalCount || 0} agregado(s)`}
        </Typography>
        {completed && <CheckCircle sx={{ color: "success.main", fontSize: 16 }} />}
      </Stack>
      {item.required && (
        <Chip
          size="small"
          label="Obligatorio"
          color="warning"
          sx={{ position: "absolute", top: 6, right: 6, height: 18 }}
        />
      )}
      <input
        accept={
          accept ||
          "image/*,.pdf,application/pdf,application/octet-stream"
        }
        type="file"
        multiple={multiple}
        onChange={handleChange}
        style={{
          position: "absolute",
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: "hidden",
          clip: "rect(0 0 0 0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      />
    </Button>
  );
}
